<script setup lang="ts">
import { IconSparkles, IconX } from '@tabler/icons-vue'

defineProps<{
  isOpen: boolean
}>()

defineEmits<{
  toggle: []
}>()
</script>

<template>
  <button
    class="fixed bottom-6 right-6 z-40 w-12 h-12 rounded-xl bg-amber-500/20 border border-amber-500/30 text-amber-400 shadow-lg hover:bg-amber-500/30 hover:border-amber-500/40 transition-all duration-200 flex items-center justify-center cursor-pointer"
    title="AI Asistent"
    @click="$emit('toggle')"
  >
    <transition
      mode="out-in"
      enter-active-class="transition duration-150"
      enter-from-class="rotate-90 scale-0 opacity-0"
      enter-to-class="rotate-0 scale-100 opacity-100"
      leave-active-class="transition duration-150"
      leave-from-class="rotate-0 scale-100 opacity-100"
      leave-to-class="-rotate-90 scale-0 opacity-0"
    >
      <IconX v-if="isOpen" class="w-5 h-5" />
      <IconSparkles v-else class="w-5 h-5" />
    </transition>
  </button>
</template>
